// Components
import { Box, Flex, Text } from 'yard-utilities/components'
import CountdownTimer from './timer/CountdownTimer'

interface CountdownBannerProps {
  discount?: number
}

const CountdownBanner = ({ discount = 77 }: CountdownBannerProps) => {
  return (
    <Box padding={{ sm: [8, 16] }} backgroundColor="red">
      <Flex alignItems="center" justifyContent="space-between">
        <div>
          <Text variant="title-4" textColor="white" spacing={{ sm: 2 }}>
            Oferta por tiempo limitado
          </Text>
          <Text variant="body-6" textColor="white">
            ¡Membresía de 1 año con un <b>{discount}%</b> de descuento!
          </Text>
        </div>

        <CountdownTimer />
      </Flex>
    </Box>
  )
}

export default CountdownBanner
